import React, { Component } from 'react';
import PortfolioDashboard from '../components/portfolioComponents/PortfolioDashboard';

export default class Portfolio extends Component {
  render() {
    return (
      <div>
        <PortfolioDashboard />
      </div>
    );
  }
}
